import { orderLegSideEnum } from '../constants/order'
import { Actions } from '../enums/OrderTicket.enum'

/**
 * Determines the order buy or sell status based on the order action.
 *
 * @param {typeof Actions} action - The action of the order, either 'BUY' or 'SELL'.
 * @returns {typeof orderLegSideEnum} - Returns 'BUY' if the action is 'BUY', 'BUY_CLOSE', 'BUY_COVER' or 'BUY_OPEN', otherwise returns 'SELL'.
 *
 * The following actions are considered 'BUY' actions:
 * - Buy Open
 * - Buy
 * - Buy Close
 * - Buy Cover
 */
export const getLegSideByAction = (action) => {
  const buyActions = [
    Actions.BuyOpen,
    Actions.Buy,
    Actions.BuyClose,
    Actions.BuyCover,
  ]

  return buyActions.includes(action)
    ? orderLegSideEnum.BUY
    : orderLegSideEnum.SELL
}
